import React from 'react';
import styled, { css } from 'styled-components';

import { PlusCircle } from '@xsolla/ui-icons';

type Props = {
  children: string;
  disabled?: boolean;
  onClick: () => void;
  dataTestId?: string;
  error?: boolean;
  type?: 'button' | 'submit' | 'reset';
};

const ErrorStyles = css`
  background-color: rgba(235, 0, 47, 0.08);
  color: rgb(235, 0, 47);
  border: 1px solid rgb(235, 0, 47);
`;

const AddFields = styled.button<{ error: boolean }>`
  ${(p) => p.theme.typography.body}
  width: 100%;
  border: 1px solid rgba(0, 115, 247, 0.32);
  background: transparent;
  display: flex;
  justify-content: space-between;
  color: ${(p) => p.theme.colors.brand};
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;

  ${(p) => p.error && ErrorStyles}
`;

const AddFieldButton = ({
  children,
  onClick,
  dataTestId,
  disabled = false,
  type,
  error = false
}: Props): JSX.Element => (
  <AddFields
    disabled={disabled}
    onClick={onClick}
    data-test-id={dataTestId}
    type={type}
    error={error}>
    <span>{children}</span>
    <PlusCircle size={24} />
  </AddFields>
);

export default AddFieldButton;
